<template></template>

<script>

export default {
    name: 'MainPage',
};

</script>